import { useState } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@shared/components/ui/card'
import { Separator } from '@shared/components/ui/separator'
import { PasswordChangeForm } from '@shared/features/settings/components/PasswordChangeForm'
import { NewsletterSettings } from '@shared/features/settings/components/NewsletterSettings'
import { PortalAccessSettings } from '@shared/features/settings/components/PortalAccessSettings'
import { ChevronRight, Home, Settings } from 'lucide-react'
import { Link } from 'react-router-dom'

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState<'portals' | 'newsletters' | 'password'>('portals')

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        {/* Breadcrumbs */}
        <nav className="flex items-center space-x-1 text-sm text-muted-foreground mb-6">
          <Link to="/" className="hover:text-foreground transition-colors">
            <Home className="h-4 w-4" />
          </Link>
          <ChevronRight className="h-4 w-4" />
          <Link to="/recent" className="hover:text-foreground transition-colors">
            Dashboard
          </Link>
          <ChevronRight className="h-4 w-4" />
          <span className="text-foreground font-medium">Instellingen</span>
        </nav>

        {/* Page Title */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold tracking-tight flex items-center gap-2 text-foreground">
            <Settings className="h-8 w-8" />
            Instellingen
          </h1>
          <p className="text-muted-foreground mt-2">
            Beheer uw accountinstellingen en voorkeuren
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {/* Sidebar Navigation */}
          <div className="md:col-span-1">
            <nav className="space-y-1">
              <button
                onClick={() => setActiveTab('portals')}
                className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  activeTab === 'portals'
                    ? 'bg-primary/10 text-primary'
                    : 'hover:bg-muted text-muted-foreground'
                }`}
              >
                Portal toegang
              </button>
              <button
                onClick={() => setActiveTab('newsletters')}
                className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  activeTab === 'newsletters'
                    ? 'bg-primary/10 text-primary'
                    : 'hover:bg-muted text-muted-foreground'
                }`}
              >
                Nieuwsbrieven
              </button>
              <button
                onClick={() => setActiveTab('password')}
                className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  activeTab === 'password'
                    ? 'bg-primary/10 text-primary'
                    : 'hover:bg-muted text-muted-foreground'
                }`}
              >
                Wachtwoord wijzigen
              </button>
            </nav>
          </div>

          {/* Main Content Area */}
          <div className="md:col-span-2">
            {activeTab === 'portals' && (
              <PortalAccessSettings />
            )}

            {activeTab === 'newsletters' && (
              <NewsletterSettings />
            )}

            {activeTab === 'password' && (
              <Card>
                <CardHeader>
                  <CardTitle>Wachtwoord wijzigen</CardTitle>
                  <CardDescription>
                    Wijzig uw wachtwoord om uw account veilig te houden. U moet uw huidige wachtwoord invoeren om door te gaan.
                  </CardDescription>
                </CardHeader>
                <Separator />
                <CardContent className="pt-6">
                  <PasswordChangeForm />
                </CardContent>
              </Card>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}